import React from 'react'
import Moment from 'react-moment'
import { StatusTag } from 'components'

export const columns = [
  {
    Header: 'Status',
    accessor: 'status',
    className: 'center',
    width: 100,
    Cell: row => (<StatusTag status={row.value} statusName={row.original.statusName} />)
  },
  {
    Header: 'Document No.',
    accessor: 'documentNumber',
    width: 100,
    className:'center',
    Cell: row => (row.value ? row.value:'-')
  },
  {
    Header: 'PO No.',
    accessor: 'poNumber',
    width: 100,
  },
  {
    Header: 'Contract',
    accessor: 'requestContract',
    headerClassName: 'left',
  },
  {
    Header: 'Title',
    accessor: 'title',
    headerClassName: 'left',
  },
  {
    Header: 'Company',
    accessor : row =>(`${row.companyCode}|${row.companyName}`),
    id:'company',
    width: 100,
  },
  {
    Header: 'Vendor',
    accessor : row =>(`${row.vendorCode||'-'}|${row.vendorName||'-'}`),
    id:'vendor',
    width: 100,
  },
  {
    Header: 'PR Requester',
    accessor: 'prRequester',
  },
  {
    Header: 'Doc date',
    accessor: 'createdDate',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Purchasing',
    accessor: 'purchasing',
  },
]

export const columnsSearchPO = [
  {
    Header: 'Doc No.',
    accessor: 'documentNumber',
    width: 100,
    className: 'center',
  },
  {
    Header: 'SAP No.',
    accessor: 'sapNumber',
    width: 120,
    className: 'center',
  },
  {
    Header: 'title',
    accessor: 'title',
  },
]

export const listAttachment = [
  { name: 'ct01', label: 'หนังสือรับรองนิติบุคคลของคู่สัญญาทั้งสองฝ่ายไม่เกิน 1 เดือน', require: true },
  { name: 'ct02', label: 'หนังสือมอบอำนาจ (กรณีที่มีการมอบอำนาจให้ทำนิติกรรมแทน)', require: true },
  { name: 'ct03', label: 'สำเนาบัตรประจำตัวประชาชน และสำเนาทะเบียนบ้านของคู่สัญญา / กรรมการ/ผู้รับมอบอำนาจ', require: true },
  { name: 'ct04', label: 'ผังองค์กรผู้รับจ้าง', require: false },
  { name: 'ct05', label: 'สัญญาของ Supplier (ถ้ามี)', require: false },
  { name: 'ct11', label: 'ใบเสนอราคา, งวดงานก่อสร้าง และเงื่อนไขการรับเงิน', require: false },
  { name: 'ct12', label: 'รายละเอียดสินค้าและบริการ/การรับประกัน/ใบรับรองมาตรฐาน', require: false },
  { name: 'ct13', label: 'แบบก่อสร้าง', require: false },
  { name: 'ct14', label: 'แผนการก่อสร้าง', require: false },
  { name: 'ct06', label: 'Other', require: false },
]